import { render, staticRenderFns } from "./BiasMail.vue?vue&type=template&id=3a44c5c8&scoped=true&"
import script from "./BiasMail.vue?vue&type=script&lang=js&"
export * from "./BiasMail.vue?vue&type=script&lang=js&"
import style0 from "./BiasMail.vue?vue&type=style&index=0&id=3a44c5c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a44c5c8",
  null
  
)

export default component.exports